import { useParams } from 'react-router-dom';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import * as Setting from '../../utils/AuthUtils';
import Deck from './Deck';
import { api } from '../../AppConfig';

function RoutedDeck() {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const deckQuery = useQuery({ 
    queryKey: [`deck-${id}`], 
    queryFn: () => 
      fetch(api.decks().detailsById(id).href, {
        headers: {
          'Authorization': 'Bearer ' + Setting.getToken(),
          'Content-Type': 'application/json',
        },
      }).then((res) =>
        res.json(), 
      )
  })

  if (!id) return (<div></div>);

  return <Deck id={id} deck={deckQuery} />;
}

export default RoutedDeck;